import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
  DropdownTriggerButton,
  Icon,
  Typography,
} from "@backpac/monica";
import { useState } from "react";

export enum VideoSortOption {
  RECENT_UPLOADS = "RECENT_UPLOADS",
  OLDEST_UPLOADS = "OLDEST_UPLOADS",
  MOST_VIEWED = "MOST_VIEWED",
  LEAST_VIEWED = "LEAST_VIEWED",
  HIGHEST_EARNING = "HIGHEST_EARNING",
  LOWEST_EARNING = "LOWEST_EARNING",
}

export const SORT_OPTIONS = {
  [VideoSortOption.RECENT_UPLOADS]: {
    label: "Recent uploads",
    value: {
      sort: "createdAt",
      order: "desc",
    },
  },
  [VideoSortOption.OLDEST_UPLOADS]: {
    label: "Oldest uploads",
    value: {
      sort: "createdAt",
      order: "asc",
    },
  },
  [VideoSortOption.MOST_VIEWED]: {
    label: "Most viewed",
    value: {
      sort: "views",
      order: "desc",
    },
  },
  [VideoSortOption.LEAST_VIEWED]: {
    label: "Least viewed",
    value: {
      sort: "views",
      order: "asc",
    },
  },
  [VideoSortOption.HIGHEST_EARNING]: {
    label: "Highest earning",
    value: {
      sort: "revenue",
      order: "desc",
    },
  },
  [VideoSortOption.LOWEST_EARNING]: {
    label: "Lowest earning",
    value: {
      sort: "revenue",
      order: "asc",
    },
  },
} as const satisfies Record<
  VideoSortOption,
  {
    label: string;
    value: {
      sort: "createdAt" | "views" | "revenue";
      order: "asc" | "desc";
    };
  }
>;

interface VideoSortProps {
  onChange: (value: VideoSortOption) => void;
  value: VideoSortOption;
}

export function VideoSort({ value, onChange }: VideoSortProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dropdown open={open} onOpenChange={setOpen}>
      <DropdownTrigger asChild>
        <DropdownTriggerButton size="md" rightAddon={<Icon name="swap" iconSize="12px" />} className="gap-2">
          <Typography size="xs" weight={600} color="textPrimary">
            {SORT_OPTIONS[value].label}
          </Typography>
        </DropdownTriggerButton>
      </DropdownTrigger>
      <DropdownContent>
        <div className="max-h-[360px] min-w-[200px] overflow-y-auto">
          {Object.entries(SORT_OPTIONS).map(([sortOption, { label }]) => (
            <DropdownItem
              key={label}
              className="flex items-center gap-1.5"
              onSelect={() => onChange(sortOption as VideoSortOption)}
            >
              <div className="flex flex-1 items-center justify-between gap-4px">
                <Typography size="sm" weight={600} color="textPrimary">
                  {label}
                </Typography>
                {value === sortOption && <Icon name="check" className="size-16px" />}
              </div>
            </DropdownItem>
          ))}
        </div>
      </DropdownContent>
    </Dropdown>
  );
}
